// @flow

import TimelineItem from "app/models/TimelineItem";
import Video from "app/models/Video";

import Service from "app/services/Service";

class TimelineItemService extends Service {
    static base = "/";

    metadata(url: string): Promise<*> {
        return this.http.get("content/metadata?url=" + url);
    }

    create(video: Video, timelineItem: TimelineItem, file?: File): Promise<*> {
        const data = this.toFormData({ ...timelineItem, file, uid: video.uid });
        return this.http.post(`video/${video.uid}/content`, data);
    }

    update(video: Video, timelineItem: TimelineItem, file?: File): Promise<*> {
        const data = this.toFormData({ ...timelineItem, file, uid: video.uid });
        return this.http.post(`content/${timelineItem.rowid}`, data);
    }

    delete(rowid: number): Promise<*> {
        return this.http.delete(`content/${rowid}`);
    }
}

export default new TimelineItemService();



// WEBPACK FOOTER //
// ./src/app/services/TimelineItemService.js